<template>
  <transition name="popup-fade">
    <div class="popup-backdrop" @click.self="close">
      <div class="popup">
        <div class="popup-title">
          <span :style="commercialNameStyle">
            {{ titleTranslate }}
          </span>
        </div>
        <div v-if="hasDescription" class="popup-description">
          <span :style="descriptionStyle">
            {{ descriptionTranslate }}
          </span>
        </div>
        <div v-if="video && useVideo" class="popup-image">
          <video autoplay loop>
            <source :src="video" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
        <div v-else-if="image" class="popup-image">
          <img :src="image" :alt="title">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { ProductProps } from '../models/styleModels/ProductProps';
import { MultiLanguageText } from '../models';

export default {
  name: 'popup-block',
  props: {
    title: { type: Object, required: true, default: () => null },
    description: { type: Object, default: () => null },
    image: { type: String },
    video: { type: String },
    productProps: { type: Object, required: true, default: () => ({}) },
    useVideo: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(['selectedLanguage']),
    myTitle() {
      return new MultiLanguageText(this.title);
    },
    myDescription() {
      return new MultiLanguageText(this.description);
    },
    myProductProps() {
      return new ProductProps(this.productProps);
    },
    hasDescription() {
      return this.descriptionTranslate.length;
    },
    titleTranslate() {
      return this.myTitle.getText(this.selectedLanguage);
    },
    descriptionTranslate() {
      return this.myDescription.getText(this.selectedLanguage);
    },
    commercialNameStyle() {
      return this.myProductProps.popupCommercialNameTextProps.getStyles();
    },
    descriptionStyle() {
      return this.myProductProps.popupLongCommercialDescriptionTextProps.getStyles();
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    beforeEnter() {
      return 'ok';
    },
  },
};
</script>

<style scoped>
  .popup-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .popup {
    background-color: #dadada;
    box-shadow: rgba(0, 0, 0, 0.29) 5px 5px 25px 0;
    border-radius: 25px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 85%;
    max-width: 450px;
    height: fit-content;
    max-height: 525px;
    padding: 20px 20px 30px 20px;
  }

  .popup-title {
    text-align: center;
    color: black;
  }

  .popup-description {
    padding-top: 15px;
    height: fit-content;
  }

  .popup-image {
    padding-top: 15px;
    display: flex;
    justify-content: center;
  }

  .popup-image img {
    max-width: 100%;
    width: auto;
    height: fit-content;
    max-height: 325px;
    border-radius: 10px;
  }

  .popup-image video {
    max-width: 100%;
    width: auto;
    height: fit-content;
    max-height: 325px;
    border-radius: 10px;
  }
</style>
